import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";

import { Button, Card, CardBody, Col, Container, Row, Table } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";

class TaxInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    document.title = "transaction-history";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="TAX Invoice" />
            <Card className="px-3">
              <h2 className="text-center text-black fw-bold py-3">
                TAX INVOICE
              </h2>

              <div className="table-responsive">
                <table className="table table-bordered foo">
                  <tbody>
                    <tr>
                      <td scope="row">
                        <h4 className="text-black fw-bold">Delivery Challan</h4>
                        <p className="fs-5">
                          Basement, Office No - 4, Shreeji Aavash, Mini Bazar,{" "}
                          <br />
                          Mangadh Chowk, Varachha Road, Surat - 395006
                        </p>
                        <p className="fs-5">State Name: Gujarat, Code : 24</p>
                        <p className="fs-5">GSTIN/UIN : 24AZEPK7171M2Z0</p>
                      </td>
                      <td className="p-0 m-0">
                        <p className="fs-5 ps-2">Invoice No.</p>
                        <h5 className="text-black fw-bold ps-2">GSTIN/UIN:</h5>
                        <hr />
                        <p className="fs-5 ps-2">Delivery Note</p>
                        <hr />
                        <p className="fs-5 ps-2">Suppliers&apos;s Ref</p>
                      </td>
                      <td className="p-0 m-0">
                        <p className="fs-5 ps-2">Dated.</p>
                        <h5 className="text-black fw-bold ps-2">23-Jun-22</h5>
                        <hr />
                        <p className="fs-5 ps-2">Mode/Term of Payment</p>
                        <hr />
                        <p className="fs-5 ps-2">Other Reference(s)</p>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        <p className="fs-5">Delivery Challan</p>
                        <h4 className="text-black fw-bold">
                          Cupid Diamonds Pvt. Ltd
                        </h4>
                        <p className="fs-5">
                          5th Floor, Krishna Niwas, Raja Ram Mohan Ray Road,
                          Charni Road, <br />
                          East, Mumbai- 400 004
                        </p>
                        <p className="fs-5">State Name: Gujarat, Code : 24</p>
                        <p className="fs-5">GSTIN/UIN : 24AZEPK7171M2Z0</p>
                      </td>
                      <td className="p-0 m-0">
                        <p className="fs-5 ps-2">Buyer&apos;s Order No.</p>
                        <hr />
                        <p className="fs-5 ps-2">Despatch Doc. No.</p>
                        <hr />
                        <p className="fs-5 ps-2">Despatch through</p>
                        <h5 className="text-black fw-bold ps-2">
                          Hand to Hand
                        </h5>
                      </td>
                      <td className="p-0 m-0">
                        <p className="fs-5 ps-2">Dated.</p>
                        <hr />
                        <p className="fs-5 ps-2">Delivery Note Date</p>
                        <hr />
                        <p className="fs-5 ps-2">Destination</p>
                        <h5 className="text-black fw-bold ps-2">Surat</h5>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        <p className="fs-5">Delivery Challan</p>
                        <h4 className="text-black fw-bold">
                          Cupid Diamonds Pvt. Ltd
                        </h4>
                        <p className="fs-5">
                          5th Floor, Krishna Niwas, Raja Ram Mohan Ray Road,
                          Charni Road, <br />
                          East, Mumbai- 400 004
                        </p>
                        <p className="fs-5">State Name: Gujarat, Code : 24</p>
                        <p className="fs-5">GSTIN/UIN : 24AZEPK7171M2Z0</p>
                        <p className="fs-5">Place Of Suppy : Maharastra</p>
                      </td>
                      <td className="p-0 m-0" colSpan="2">
                        <p className="fs-5 ps-2">Term of Delivery</p>
                        <p className="fs-5 ps-2">Bank: Federal Bank</p>
                        <p className="fs-5 ps-2">A/c No.: 18650200020693</p>
                        <p className="fs-5 ps-2">IFSC Code: FDRL0001865</p>
                        <p className="fs-5 ps-2">
                          Branch Name: Hirabaug, Varachha Branch
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="background-light fs-5">
                    <tr>
                      <th scope="col">sr No.</th>
                      <th scope="col">Description of Goods</th>
                      <th scope="col">HSN Code</th>
                      <th scope="col">Quantity (in Crts)</th>
                      <th scope="col">Rate</th>
                      <th scope="col">Per</th>
                      <th scope="col">Amount (in Rs.)</th>
                    </tr>
                  </thead>
                  <tbody className="foo">
                    <tr>
                      <td scope="row">01</td>
                      <td>Diamond Processing Jobwork Charges [H]</td>
                      <td>9988</td>
                      <td>1685.100</td>
                      <td>1400.00</td>
                      <td>Crts</td>
                      <td>2,359,140.00</td>
                    </tr>
                    <tr>
                      <td scope="row">02</td>
                      <td>Diamond Processing Jobwork Charges [Jiram]</td>
                      <td>9988</td>
                      <td>28.510</td>
                      <td>2800.00</td>
                      <td>Crts</td>
                      <td>2,359,140.00</td>
                    </tr>
                  </tbody>
                  <tfoot className="fs-5">
                    <tr className="background-light foo">
                      <th></th>
                      <th>Total:</th>
                      <th></th>
                      <th>1713.610</th>
                      <th></th>
                      <th></th>
                      <th>2,475,553.00</th>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div className="row">
                <div className="d-lg-flex d-block text-center justify-content-lg-between">
                  <p className="fs-5">Amount Chargeable (In words) :</p>
                  <p className="fs-5">E. & O.E.</p>
                </div>
                <h4 className="fw-bold text-black">
                  INR Twenty Four Lakhs Seventy Five Thousand Five Hundred Fifty
                  Three Only
                </h4>
                <p className="fs-5 text-black fw-bold">Declaration:</p>
                <p className="fs-5">
                  (1) There is possibility of complete damage of the stone as
                  result of high pressure cell decompressing during HPHT run.
                  Probability of this situation is 3% per 100 Cycles. All risk
                  of goods being damaged during HPHT will be barred by Customer.
                </p>
                <p className="fs-5">
                  (2) Out of the two copies of bill along with the goods, kindly
                  return one signed copy as an evidence of acknowledgement
                  received by you. Once the goods have been received, Confirmed
                  by signing Bill, no claim, arguments or complaints shall be
                  entertained regarding weight, purity, charni, category and the
                  Quality of the diamonds.
                </p>
                <p className="fs-5">(3)Subject to Surat jurisdiction only.</p>
                <p className="fs-5 text-black fw-bold">Terms and Conditions</p>
                <p className="fs-5">
                  (1) There is possibility of complete damage of the stone as
                  result of high pressure cell decompressing during HPHT run.
                  Probability of this situation is 3% per 100 Cycles. All risk
                  of goods being damaged during HPHT will be barred by Customer.
                </p>
                <p className="fs-5">
                  (2) Out of the two copies of bill along with the goods, kindly
                  return one signed copy as an evidence of acknowledgement
                  received by you. Once the goods have been received, Confirmed
                  by signing Bill, no claim, arguments or complaints shall be
                  entertained regarding weight, purity, charni, category and the
                  Quality of the diamonds.
                </p>
                <p className="fs-5">(3)Subject to Surat jurisdiction only.</p>
                <hr />
                <p className="fs-5 pt-2">
                  Signed this day as our acceptance and declarations to the
                  above effect by:
                </p>
                <div className="d-lg-flex d-block text-center justify-content-lg-between">
                  <p className="fs-5">
                    For <strong> Receiver:</strong>
                  </p>
                  <p className="fs-5">
                    for <strong> P3Y Diamond Tech</strong>
                  </p>
                </div>
                <p className="text-center text-lg-end fs-5">
                  Authorised Signatory
                </p>
              </div>
            </Card>

            <div className="col-md-12 text-lg-end py-5 text-center no-print">
              <Button
                onClick={e => window.print(e.preventDefault())}
                color="success"
                className="fs-4"
                type="submit"
              >
                <img src="images/dashboard-images/printwhite.svg" alt="print" />
              </Button>
              <Button
                onClick={e => window.print(e.preventDefault())}
                color="primary"
                className="fs-4 px-5 ms-2"
                type="Back"
              >
                Print
              </Button>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default TaxInvoice;
